import '@/assets/style/companyList.scss';
import { HotKeys } from 'react-hotkeys';
import 'react-toastify/dist/ReactToastify.css';
import useKeyboardShortcuts from './layouts/componets/KeyboardShortcut';
import ModalManager from './layouts/componets/ModalManager';
import RouteSetup from './routes/RouteSetup';
import { AppThemeProvider } from './theme';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { showToast } from './utils/toastMessage/ToastMessage';
import { Suspense, useEffect } from 'react';
import { Spin } from 'antd';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/Store';
import { PersistGate } from 'redux-persist/integration/react';
import { ErrorBoundary } from 'react-error-boundary';
import { setGlobalNavigate } from './apiError/newServices';
import { useNavigate } from 'react-router-dom';

function App() {
  const navigate = useNavigate();
  const ErrorFallbackComponent = ({ error, resetErrorBoundary }) => (
    <div className="tw-flex tw-h-[100vh] tw-justify-center tw-items-center tw-flex-col tw-bg-gradient-to-br tw-from-gray-100 tw-via-gray-200 tw-to-gray-100">
      <div
        role="alert"
        className="tw-p-4 tw-bg-red-100 tw-text-red-700 max-w-xl tw-rounded"
      >
        <p className="tw-font-semibold tw-mb-2">Something went wrong:</p>
        <pre
          className="tw-whitespace-pre-wrap tw-break-words tw-mb-4"
          style={{ maxHeight: 300, overflowY: 'auto' }}
        >
          {error?.message || 'An unexpected error occurred'}
          <br />
          {error?.stack}
        </pre>
        <button
          onClick={resetErrorBoundary}
          className="tw-px-4 tw-py-2 tw-bg-blue-500 tw-cursor-pointer tw-text-white tw-rounded hover:tw-bg-blue-600"
        >
          Try again
        </button>
      </div>
    </div>
  );

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        onError: (err) => {
          showToast('error', `${err?.response}`);
        },
      },
      mutations: {
        // onError: (err) => {
        //   showToast('error', `${err?.response}`);
        // },
      },
    },
  });

  // const queryClient = new QueryClient({});
  const { keyMap, handlers, visibleModals, closeModal } =
    useKeyboardShortcuts();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return (
    <HotKeys keyMap={keyMap} handlers={handlers}>
      <Suspense
        fallback={
          <div className="tw-flex tw-h-[100vh] tw-justify-center tw-items-center">
            <Spin />
          </div>
        }
      >
        <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
          <Provider store={store}>
            <PersistGate loading={'loading...'} persistor={persistor}>
              <QueryClientProvider client={queryClient}>
                <AppThemeProvider>
                  <RouteSetup />
                  <ModalManager
                    visibleModal={visibleModals}
                    closeModal={closeModal}
                  />
                </AppThemeProvider>
              </QueryClientProvider>
            </PersistGate>
          </Provider>
        </ErrorBoundary>
      </Suspense>
    </HotKeys>
  );
}

export default App;
